/**
 * Zoom der Lese-Ansicht (1 = 100 %) — eigenes Modul ohne PDF.js, damit die
 * Leiste von `PdfDocumentView` es nutzen kann, ohne den Viewer zu laden.
 */
export const ZOOM_START = 1.2;
const ZOOM_MIN = 0.5;
const ZOOM_MAX = 3;
const SCHRITT = 0.2;

const runde = (v: number) => Math.round(v * 100) / 100;
export const zoomKleiner = (s: number) => Math.max(ZOOM_MIN, runde(s - SCHRITT));
export const zoomGroesser = (s: number) => Math.min(ZOOM_MAX, runde(s + SCHRITT));
